var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"item"},[_c('transition',{attrs:{"name":"slide-in"}},[(_vm.inViewport)?[_vm._t("default")]:_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }